import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Pagination.css';
import { ClickElement } from '../form';
import { Link } from 'react-router-dom';
import { PAGINATION } from '../../lib/labels';

export const Pagination = ({ offset, pathPrefix }) => {

  const createPath = (numOfDays, direction) => {
    const goToPage = direction === 'back' ? Number(offset) - numOfDays : Number(offset) + numOfDays;
    return `${pathPrefix}/${goToPage}`;
  };
  
  return (
    <div className={styles.pagination}>
      {(offset - 6) > 0 && (
        <ClickElement
          tertiary
          ElementType={Link}
          to={createPath(7, 'back')}
          type="button"
          text={(<><FontAwesomeIcon icon="angle-double-left" size="sm" /> {PAGINATION.WEEK}</>)}          
        />
      )}          
      {offset > 0 && (             
        <ClickElement
          tertiary
          ElementType={Link}
          to={createPath(1, 'back')}
          type="button"
          text={(<><FontAwesomeIcon icon="angle-left" size="sm" /> {PAGINATION.DAY}</>)}          
        />
      )}
      {offset < 365 && (
        <ClickElement
          tertiary
          ElementType={Link}
          to={createPath(1, 'forward')}
          type="button"
          text={(<>{PAGINATION.DAY} <FontAwesomeIcon icon="angle-right" size="sm" /></>)}
        />
      )}
      {offset < (365 - 6) && (
        <ClickElement
          tertiary
          ElementType={Link}
          to={createPath(7, 'forward')}
          type="button"
          text={(<>{PAGINATION.WEEK} <FontAwesomeIcon icon="angle-double-right" size="sm" /></>)}
        />
      )}
    </div>
  );
};